(function ($) {
	const blockSlug = 'faq';
	const initializeBlock = function ($block) {

		// START your JS code

		const faqButton = $('.acf-block-faq-list__title-wrapper');

		faqButton.each(function() {
			$(this).on('click', function() {
				const $question = $(this);
				const $switchFaqButton = $question.find('.switch-faq-button');
				$question.next().slideToggle( 300 );
				$question.toggleClass('is-faq-visible');
				if ( $question.hasClass('is-faq-visible') ) {
					$switchFaqButton.text('-');
				} else {
					$switchFaqButton.text('+');
				}
			});
		});

		// END your JS code

	};

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		$('.acf-block-' + blockSlug).each(function () {

			initializeBlock($(this));

		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=' + blockSlug, initializeBlock);
	}
})(jQuery);
